import {
	getTeamDetails,
	listTeams,
	TeamDetailsViewModel,
	TeamListItemViewModel
} from "client/Api/Workspace/LiveInformation/Teams/teamsLiveInformation";

export class TeamsProvider {

	private readonly _isTeamsAvailable: boolean;
	private _pendingListRequest: Promise<readonly TeamListItemViewModel[]> | null;
	private readonly _pendingDetailsRequests: Map<string, Promise<TeamDetailsViewModel>>;

	public get isAvailable(): boolean {
		return this._isTeamsAvailable;
	}

	constructor(isTeamsAvailable: boolean) {
		this._isTeamsAvailable = isTeamsAvailable;
		this._pendingListRequest = null;
		this._pendingDetailsRequests = new Map<string, Promise<TeamDetailsViewModel>>();
	}

	public list(): Promise<readonly TeamListItemViewModel[]> {
		if (this._pendingListRequest === null) {
			this._pendingListRequest = listTeams();
		}

		return this._pendingListRequest;
	}

	public details(id: string): Promise<TeamDetailsViewModel> {
		if (!this._pendingDetailsRequests.has(id)) {
			this._pendingDetailsRequests.set(
				id,
				getTeamDetails(id)
			);
		}

		return this._pendingDetailsRequests.get(id)!;
	}
}
